import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  invalidLogin: boolean;
  loginError = '';

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  signIn(credentials) {
    this.authService.login(`${credentials.name}:${credentials.password}`).subscribe(
      (result) => {
        if (result) {
          this.router.navigate(['/labeling-page']);
        } else {
          this.invalidLogin = true;
        }
      },
      (error) => {
        this.loginError = error;
      },
    );
  }
}
